import { AbstractControl, ValidationErrors } from '@angular/forms';

/** Reject decimals (incl. "12.0" / "12.") — Number.isInteger(parseFloat()) is too loose. */
export function integerValidator(control: AbstractControl): ValidationErrors | null {
    if (control.value === null || control.value === undefined || control.value === '') {
        return null;
    }
    return /^-?\d+$/.test(String(control.value).trim().replace(',', '.')) ? null : { notInteger: true };
}

/** Read form field for child index from `{ value.0 }` keys or a plain array. */
function groupFormValueAt(formValue: Record<string, unknown> | unknown[], index: number): unknown {
    if (Array.isArray(formValue)) {
        return formValue[index];
    }
    const keyed = formValue[`value.${index}`];
    if (keyed !== undefined) {
        return keyed;
    }
    const matchKey = Object.keys(formValue).find(k => k.endsWith(`.${index}`));
    return matchKey !== undefined ? formValue[matchKey] : undefined;
}

/**
 * Map dialog form `{ value.0, value.1 }` (or a plain array) to child values by dataType.
 */
export function mapGroupFormValueToChildValues(
    children: { dataType?: string }[] | undefined,
    formValue: Record<string, unknown> | unknown[],
): unknown[] {
    return (children || []).map((child, i) => {
        const v = groupFormValueAt(formValue, i);
        const type = (child.dataType || '').toLowerCase();

        if (type === 'boolean') {
            return v === true || String(v).toLowerCase() === 'true' ? 'true' : 'false';
        }
        if (type === 'text') {
            return v;
        }
        return v === '' || v == null ? v : Number(v);
    });
}

/** True when documented group child value differs from the form/mapped value. */
export function groupChildValueHasChanged(
    childDataType: string | undefined,
    parentDataType: string | undefined,
    newValue: unknown,
    existingValue: unknown,
): boolean {
    const childType = (childDataType || '').toLowerCase();
    const parentType = (parentDataType || '').toLowerCase();
    const compareAsString = childType === 'boolean' || childType === 'text' || parentType === 'group-text';

    return compareAsString ? String(newValue) !== String(existingValue) : +newValue !== +existingValue;
}
